import { inject, Injectable, signal } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Permission } from '../../interfaces/permission.pojo';
import { ZeissIdContact } from '../../interfaces/zeissid-contact.interface';
import { ZeissIdOrganisation } from '../../interfaces/zeissid-organisation.interface';
import { ZeissIdUser } from '../../interfaces/zeissid-user.interface';

@Injectable({
  providedIn: 'root',
})
export class UserData {
  private authService = inject(MsalService);

  readonly userData = signal<
    ZeissIdUser & ZeissIdContact & ZeissIdOrganisation
  >({
    accountId: 0,
    eMail: '',
    firstName: '',
    identityProvider: 0,
    lastChange: '',
    lastName: '',
    salution: '',
    language: '',
    country: '',
    organisationId: 0,
    name: '',
    street: '',
    houseNumber: '',
    city: '',
    zip: '',
    zeissCustomerNo: null,
    zeissSecondaryReference: null,
    zeiss3rdPartySystem: null,
    federalState: '',
    group: false,
    parentOrganisationId: null,
    organisationVerification: 0,
  });

  readonly permissions = signal<Permission[]>([]);

  public updateUserData(
    user: ZeissIdUser & ZeissIdContact & ZeissIdOrganisation,
  ) {
    this.userData.set(user);
  }

  public updatePermissions(permissions: Permission[]) {
    this.permissions.set(permissions);
  }

  public hasPermission(permission: Permission): boolean {
    return this.permissions().includes(permission);
  }

  public logout(): void {
    this.authService.logout();
  }
}
